import React, { useState, useEffect } from 'react';
import { Origin } from '../../../../types';
import { Button } from '../../../../components/ui/Button';
import Input from '../../../../components/ui/Input';
import Modal from '../../../../components/ui/Modal';

interface OriginFormModalProps {
    isOpen: boolean;
    onClose: () => void;
    onSave: (data: Omit<Origin, 'id' | 'createdAt'>) => Promise<void>;
    originToEdit?: Origin;
}

const OriginFormModal: React.FC<OriginFormModalProps> = ({ isOpen, onClose, onSave, originToEdit }) => {
    const [name, setName] = useState('');
    const [isSaving, setIsSaving] = useState(false);

    useEffect(() => {
        if (isOpen) {
            setName(originToEdit?.name ?? '');
        }
    }, [isOpen, originToEdit]);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setIsSaving(true);
        try {
            await onSave({ name });
        } finally {
            setIsSaving(false);
        }
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose} size="lg">
            <Modal.Header onClose={onClose}>
                {originToEdit ? 'Editar Origem' : 'Nova Origem'}
            </Modal.Header>
            <Modal.Body>
                <form id="origin-form" onSubmit={handleSubmit}>
                    <Input
                        label="Nome"
                        name="name"
                        type="text"
                        required
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        placeholder="Ex: Instagram, Indicação..."
                        autoFocus
                    />
                </form>
            </Modal.Body>
            <Modal.Footer className="flex-col-reverse gap-2 sm:flex-row">
                <Button variant="secondary" onClick={onClose} className="w-full sm:w-auto" disabled={isSaving}>
                    Cancelar
                </Button>
                <Button type="submit" form="origin-form" className="w-full sm:w-auto" disabled={isSaving}>
                    {isSaving ? 'Salvando...' : 'Salvar'}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default OriginFormModal;
